import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export function EthicsComplianceBanner() {
  return (
    <div className="relative bg-primary/85 backdrop-blur-xl text-white py-5 border-y border-accent/15 shadow-[0_-8px_30px_-12px_rgba(0,0,0,0.45)] overflow-hidden">
      {/* Subtle paper texture + gold glow to match the Navbar sticky state */}
      <div className="absolute inset-0 texture-paper opacity-25 pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[40%] h-[120%] bg-accent/[0.06] blur-[100px] rounded-full pointer-events-none" />
      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <ShieldCheck className="w-6 h-6 text-accent flex-shrink-0" />
          <p className="text-sm md:text-base font-medium leading-relaxed">
            Committed to a Higher Standard than most — awareness, transparency,
            and ethical conduct.
          </p>
        </div>
        <Link
          to="/terms"
          className="flex-shrink-0 text-sm text-accent hover:text-white underline underline-offset-4 transition-colors whitespace-nowrap"
        >
          Review our Code of Ethics &amp; Disclosures
        </Link>
      </div>
    </div>
  );
}
